import { writable, get } from 'svelte/store';
import map from 'lodash/map';
import filter from 'lodash/filter';
const isFullName = (fullName) => {
    if (typeof fullName !== 'string')
        return false;
    return /[a-z]+/i.test(fullName);
};
const isEmail = (email) => {
    if (typeof email !== 'string')
        return false;
    return /^\w([.-]?\w+)*@\w([.-]?\w+)*(.\w{2,3})+$/.test(email);
};
const isPhone = (phone) => {
    if (typeof phone !== 'string')
        return false;
    return /^((\+|00)[0-9]{3})?[0-9]{9}$/.test(phone);
};
export const reservationFieldStatuses = writable({
    fullName: { error: null },
    email: { error: null },
    phone: { error: null },
    mmb_rz_tp: { error: null },
});
export const reservationFormValidation = (data) => {
    const fields = get(reservationFieldStatuses);
    map(fields, (field) => field.error = null);
    if (data.fullName === null || data.fullName.length === 0) {
        fields.fullName.error = 'Zadejte jméno a příjmení';
    }
    else if (isFullName(data.fullName) === false) {
        fields.fullName.error = 'Zadejte jméno a příjmení';
    }
    if (data.email === null || data.email.length === 0) {
        fields.email.error = 'Zadejte e-mail';
    }
    else if (isEmail(data.email) === false) {
        fields.email.error = 'Zadejte e-mail ve správném tvaru';
    }
    if (data.phone === null || data.phone.length === 0) {
        fields.phone.error = 'Zadejte telefon';
    }
    else if (isPhone(data.phone) === false) {
        fields.phone.error = 'Zadejte telefon ve správném tvaru';
    }
    if (data.isMmbRzSp && data.mmb_rz_tp === null || String(data.mmb_rz_tp).length === 0) {
        fields.mmb_rz_tp.error = 'Zadejte označení vozidla, u kterého požadujete provést registrační úkon. V případě první registrace vozidla zadejte posledních 7 míst čísla VIN vašeho vozidla. (Názorný příklad: V případě vozidla označeného VIN: TMBGDM9A1KP042788 uveďte znaky P042788).';
    }
    reservationFieldStatuses.set(fields);
    return filter(fields, (field) => field.error !== null).length ? false : true;
};
